<template>
  <div class='tasks-operation'>
    
    <span class="mr-3">
      <span v-if="selectedIds.length">
        <button type='button' class='btn btn-primary btn-sm' v-on:click="exportSpreadSheet">导出</button>
      </span>
    </span>
    <form id='export-spreadsheet-form' enctype='multipart/form-data' method='post' action='/api/tasks/spreadsheet'>
      <input type='hidden' name='task_ids'>
    </form>

  </div>
</template>

<script>
// 导出excel事件
function exportSpreadSheet () {
  let form = document.getElementById('export-spreadsheet-form')
  form.querySelector('input[name="task_ids"]').setAttribute('value', this.selectedIds.join(','))
  form.submit()
}

export default {
  name: 'tasks-operation',
  props: ['selectedIds'],
  data () {
    return {
    }
  },
  methods: {
    exportSpreadSheet
  }
}
</script>

<style lang='scss'>
  .tasks-operation{
    display: inline-block;
  }
</style>
